module.exports = __webpack_public_path__ + "img/facepaint_en.33b0370.jpg";